import { apiClient } from './apiClient';

export type TaxPaymentType = {
  id: number;
  name: string;
};

export const getTaxPaymentTypes = (): Promise<TaxPaymentType[]> =>
  apiClient.get('/tax-payment-types', {});
